<div class="container-fluid">
	<header>
		<div clas="row">
			<div class="page-title"><span>{{getCaption()}}</span></div>
			<div class="vaillant-logo">
				<div class="logo-container"></div>
			</div>
		</div>
	</header>
</div>